<template>
  <div class="companion_teacher">
    <div class="teacher_list" v-if="teacherList.length">
      <div class="teacher_one mb-15 flex Flexalign FlexBetween p-20" v-for="(item, index) in teacherList" :key="index">
        <div class="teacher_left flex Flexalign">
          <el-image class="teacher_avatar" :src="item.image"></el-image>
          <div class="ml-15 teacher_info">
            <div class="flex Flexalign">
              <div>{{ item.name }}</div>
              <!-- <div
                class="qrcode ml-10 cursor_pointer flex Flexalign"
                v-if="item.image"
                @mouseenter="showTeacherQrcode(item)"
                @mouseleave="hideTeacherQrcode(item)"
              > -->
              <div class="qrcode ml-10 cursor_pointer flex Flexalign" v-if="item.image"
                @click="showTeacherQrcode(item)">
                <div>二维码</div>
                <div class="ml-5">></div>
                <!-- <div class="qrcode_box" v-if="showTeacherTutorId == item.tutorId">
                  <qrcode-vue :value="item.image" :size="80"></qrcode-vue>
                </div> -->
              </div>
            </div>
            <div class="teacher_phone">联系电话：{{ item.phone }}</div>
          </div>
        </div>
        <div class="teacher_right cursor_pointer" @click="askQuestion(item)">
          <el-image class="teacher_bg" :src="iconPath('teacher_bg.png')"></el-image>
          <div class="teacher_text">伴学师服务</div>
        </div>
      </div>
    </div>
    <div v-else>
       <moe-empty url="moe_empty_bg_img.png" emptyText="暂无伴学师"></moe-empty>
    </div>
    <addQuestion ref="addQuestion" :companionTeacherInfo="companionTeacherInfo" :courseDetail="{}"></addQuestion>
    <teacherQrcode ref="teacherQrcode"></teacherQrcode>
  </div>
</template>

<script>
// import QrcodeVue from "qrcode.vue";
import addQuestion from "@/components/popup/addQuestion.vue";
import teacherQrcode from '@/components/popup/teacherQrcode.vue';
export default {
  name: "GjkcH5CompanionTeacher",
  components: {
    // QrcodeVue,
    addQuestion, teacherQrcode
  },

  data() {
    return {
      teacherList: [],
      showTeacherTutorId: "",
      companionTeacherInfo: {}
    };
  },

  mounted() {
    this.getMyTeacherList();
  },

  methods: {
    getMyTeacherList() {
      this.$Api.user
        .getMyTeacherList()
        .then((res) => {
          this.teacherList = res.data.data;
        })
        .catch(() => { });
    },
    showTeacherQrcode(info) {
      this.showTeacherTutorId = info.tutorId;
      this.$refs.teacherQrcode.qrcodeValue = info.image;
      this.$refs.teacherQrcode.teacherQrcodeShow = true;
    },
    hideTeacherQrcode() {
      this.showTeacherTutorId = "";
    },
    askQuestion(info) {
      this.companionTeacherInfo = info;
      this.$refs.addQuestion.addQuestionShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.companion_teacher {
  min-height: 500px;

  .teacher_list {
    .teacher_one {
      width: 628px;
      height: 86px;
      background: #fafafa;
      border-radius: 12px;
      box-sizing: border-box;

      .teacher_left {
        .teacher_avatar {
          width: 46px;
          height: 46px;
          border-radius: 50%;
        }

        .teacher_info {
          height: 46px;

          .qrcode {
            // width: 55px;
            height: 22px;
            background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
            border-radius: 12px 16px 16px 2px;
            font-size: 10px;
            color: #ffffff;
            line-height: 22px;
            padding: 0 6px;
            box-sizing: border-box;
            position: relative;

            .qrcode_box {
              position: absolute;
              left: 60px;
            }
          }

          .teacher_phone {
            font-size: 12px;
            color: #606060;
          }
        }
      }

      .teacher_right {
        position: relative;

        .teacher_bg {
          width: 68px;
          height: 68px;
        }

        .teacher_text {
          width: 68px;
          text-align: center;
          position: absolute;
          font-size: 11px;
          color: #606060;
          bottom: 10px;
        }
      }
    }
  }
}
</style>
